<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m13.905 5.949.972-.972-.954-.954-.972.972A6.268 6.268 0 0 0 9 3.6a6.295 6.295 0 0 0-6.3 6.3c0 3.483 2.817 6.3 6.3 6.3 3.483 0 6.3-2.817 6.3-6.3a6.268 6.268 0 0 0-1.395-3.951ZM9 14.85A4.959 4.959 0 0 1 4.05 9.9 4.959 4.959 0 0 1 9 4.95a4.959 4.959 0 0 1 4.95 4.95A4.959 4.959 0 0 1 9 14.85Zm2.25-13.5h-4.5V2.7h4.5V1.35Z"/>
    <path d="M9.675 6.3h-1.35v4.5h1.35V6.3Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
